import React, { Component } from 'react';
import classNames from 'classnames';

export interface DrawerProps {
  className?: string;
  /**
   * ポジション. `top`, `right`, `bottom`, `left` の4パターン
   */
  position?: 'top' | 'right' | 'bottom' | 'left';
  /**
   * ドロワーが開いているかどうか
   */
  isOpen: boolean;
  /**
   * オーバーレイ(ドロワーの背景)を透明にするかどうか
   */
  isOverayTransparent?: boolean;
  /**
   * オーバーレイを非表示にするかどうか（背景での入力やスクロールを許可する）
   */
  isNoOverlay?: boolean;
  /**
   * 開いたときのアクション
   */
  onOpen?: () => void;
  /**
   * 閉じたときのアクション
   */
  onClose?: () => void;
}

interface DrawerState {}

export class Drawer extends Component<DrawerProps, DrawerState> {
  constructor(props: DrawerProps) {
    super(props);
  }

  componentWillUpdate(nextProps: DrawerProps) {
    if (!this.props.isOpen && nextProps.isOpen) {
      this.props.onOpen && this.props.onOpen();
    }
  }

  render() {
    const { className, position = 'top', isOpen, isOverayTransparent = false, isNoOverlay = false, onClose, children } = this.props;

    const classes = classNames('uc-drawer', isOpen && 'uc-drawer--open', isNoOverlay && 'uc-drawer--no-overlay');

    return (
      <div className={classes}>
        {!isNoOverlay && (
          <div className='uc-drawer__overlay' style={isOverayTransparent ? { background: 'transparent' } : {}} onClick={onClose} />
        )}
        <div className={classNames(`uc-drawer__${position}-drawer`, className)}>{children}</div>
      </div>
    );
  }
}

export default Drawer;
